import { log } from './log';
/**
 * Utility functions for managing post-onboarding user intent
 * Stores user's original location and intended action before redirecting to onboarding
 */

export enum OnboardingAction {
  FollowCompany = 'followCompany',
  ViewReport = 'viewReport',
  CreateReview = 'createReview',
  OpenChat = 'openChat',
  ViewDeepDive = 'viewDeepDive',
  CreateIntelligenceRequest = 'createIntelligenceRequest',
  JoinDiscussion = 'joinDiscussion',
  None = 'none',
}

export interface OnboardingIntent {
  action: OnboardingAction;
  returnUrl: string;
  // Optional context data for specific actions
  companyId?: string;
  companyName?: string;
  reviewId?: string;
  reviewIds?: number[];
  [key: string]: any;
}

const STORAGE_KEY = 'postOnboardingIntent';

/**
 * Store user's intent before redirecting to onboarding
 */
export function storeOnboardingIntent(intent: OnboardingIntent): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  } catch (error) {
    log.error('Failed to store onboarding intent:', error);
  }
}

/**
 * Retrieve stored user intent
 */
export function getOnboardingIntent(): OnboardingIntent | null {
  try {
    const intentStr = sessionStorage.getItem(STORAGE_KEY);
    if (!intentStr) {
      return null;
    }
    return JSON.parse(intentStr) as OnboardingIntent;
  } catch (error) {
    log.error('Failed to retrieve onboarding intent:', error);
    return null;
  }
}

/**
 * Clear stored user intent
 */
export function clearOnboardingIntent(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    log.error('Failed to clear onboarding intent:', error);
  }
}

/**
 * Check if there is a stored intent
 */
export function hasOnboardingIntent(): boolean {
  return sessionStorage.getItem(STORAGE_KEY) !== null;
}
